import CommonDrawerHeader from "../../../../../common/CommonDrawerHeader";
import * as React from "react";
import CustomTabs, { CustomTabPanel } from "../../../../../common/CustomTabs";
import MediaAssets from "./MediaAssets";
import DocumentAssets from "./DocumentAssets";
import LinksAssets from "./LinksAssets";

const ChatAssetsTabs = ({ onClose }: { onClose: () => void }) => {
  const tabs = [
    {
      label: "Media",
      index: 0,
    },
    {
      label: "Docs",
      index: 1,
    },
    {
      label: "Links",
      index: 2,
    },
  ];
  const activeTab = 0;
  const [tabValue, setTabValue] = React.useState(activeTab);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };
  return (
    <>
      <CommonDrawerHeader
        showBackButton={true}
        onBackButtonClick={onClose}
        title=""
      />
      <CustomTabs
        tabs={tabs}
        uniqueKey="assets"
        handleChange={handleChange}
        tabValue={tabValue}
      />
      <CustomTabPanel
        renderOnlySelectedPanel
        index={0}
        value={tabValue}
        uniqueKey="assets"
      >
        <MediaAssets />
      </CustomTabPanel>
      <CustomTabPanel
        renderOnlySelectedPanel
        index={1}
        value={tabValue}
        uniqueKey="assets"
      >
        <DocumentAssets />
      </CustomTabPanel>
      <CustomTabPanel
        renderOnlySelectedPanel
        index={2}
        value={tabValue}
        uniqueKey="assets"
      >
        <LinksAssets />
      </CustomTabPanel>
    </>
  );
};

export default ChatAssetsTabs;
